/* VELANTH — fade-in animaties + FAQ accordion */
(function(){
  function init(){
    // Fade-in bij scrollen
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting) { e.target.classList.add('vl-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      document.querySelectorAll('.vl-fade').forEach(function(el){ io.observe(el); });
    } else {
      document.querySelectorAll('.vl-fade').forEach(function(el){ el.classList.add('vl-in'); });
    }

    // FAQ accordion
    document.querySelectorAll('.vl-q button').forEach(function(btn){
      btn.addEventListener('click', function(){
        var q = btn.parentElement;
        var a = q.querySelector('.vl-a');
        var open = q.classList.toggle('vl-open');
        btn.setAttribute('aria-expanded', open);
        a.style.maxHeight = open ? a.scrollHeight + 'px' : '0px';
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  // Shopify theme editor: opnieuw initialiseren als een sectie wordt herladen
  document.addEventListener('shopify:section:load', init);
})();
